import styled from 'styled-components';

/** Hugs the wrapped control (inline-flex), or spans its row for a full-width one (`$fill`). Layout only, no paint. */
export const Root = styled.span<{ $fill: boolean }>`
  display: ${({ $fill }) => ($fill ? 'flex' : 'inline-flex')};
  ${({ $fill }) => ($fill ? 'width: 100%;' : '')}
`;
